// For <turnstile-widget ref="turnstileWidget" execution="execute">.

// longer than the widget's own script + challenge timeouts, and paused while
// the user is answering a checkbox challenge
const AWAIT_TOKEN_MS = 30000
const VERIFICATION_ERROR = isInAppBrowser()
  ? 'Verification failed. Please try again, or open this page in a separate browser application.'
  : 'Verification failed. Please try again, or refresh the page.'

function isInAppBrowser () {
  const agent = navigator.userAgent || ''
  return /FBAN|FBAV|FB_IAB|Instagram|Line\/|LinkedInApp|Snapchat|TikTok|musical_ly|BytedanceWebview|MicroMessenger|Pinterest|GSA\//.test(agent) ||
    // iOS in-app browsers leave Safari/ out of the user agent
    (/iPhone|iPad|iPod/.test(agent) && !/Safari\//.test(agent)) ||
    /; wv\)/.test(agent)
}

export const TurnstileExecuteMixin = {
  data () {
    return {
      recaptcha: '',
      recaptchaMessage: '',
      pendingRecaptcha: false,
      pendingRecaptchaTimer: null,
      afterRecaptcha: null
    }
  },
  methods: {
    // runs the check, then calls onVerified once the token arrives
    requestRecaptcha (onVerified) {
      this.afterRecaptcha = onVerified
      this.recaptchaMessage = ''
      this.startPending()
      // the widget may have only just been rendered
      this.$nextTick(() => {
        if (this.$refs.turnstileWidget) {
          this.$refs.turnstileWidget.ensureRunning()
        }
      })
    },
    startPending () {
      this.stopPending()
      this.pendingRecaptcha = true
      this.startPendingTimer()
    },
    startPendingTimer () {
      clearTimeout(this.pendingRecaptchaTimer)
      this.pendingRecaptchaTimer = setTimeout(() => {
        if (this.pendingRecaptcha) {
          this.pendingRecaptcha = false
          this.recaptchaMessage = VERIFICATION_ERROR
        }
      }, AWAIT_TOKEN_MS)
    },
    pauseRecaptchaWait () {
      clearTimeout(this.pendingRecaptchaTimer)
      this.pendingRecaptchaTimer = null
    },
    resumeRecaptchaWait () {
      if (this.pendingRecaptcha) {
        this.startPendingTimer()
      }
    },
    stopPending () {
      clearTimeout(this.pendingRecaptchaTimer)
      this.pendingRecaptchaTimer = null
      this.pendingRecaptcha = false
    },
    handleRecaptchaToken (token) {
      this.recaptcha = token
      this.recaptchaMessage = ''
      if (this.pendingRecaptcha && this.afterRecaptcha) {
        this.stopPending()
        this.afterRecaptcha()
      }
    },
    handleRecaptchaError (code) {
      this.recaptcha = ''
      console.warn('Turnstile failed', { code })
      if (this.pendingRecaptcha) {
        this.stopPending()
        this.recaptchaMessage = VERIFICATION_ERROR
      }
    },
    clearRecaptcha () {
      this.recaptcha = ''
      if (this.recaptchaMessage === VERIFICATION_ERROR) {
        this.recaptchaMessage = ''
      }
    },
    resetRecaptcha () {
      // tokens are single use
      this.recaptcha = ''
      this.stopPending()
      if (this.$refs.turnstileWidget) {
        this.$refs.turnstileWidget.resetWidget()
      }
    }
  },
  beforeDestroy () {
    clearTimeout(this.pendingRecaptchaTimer)
  }
}
